module.exports = __webpack_public_path__ + "img/idea.ad448d28.svg";